import React from "react";
import { Link } from "react-router-dom";
import "./Pages.css";

function About() {
  return (
    <article className="page-content">
      <h1>About CountyLee</h1>
      <p>
        CountyLee is an out-of-county mileage calculator built for professional drivers who need accurate records of how many miles they drive outside their home county. The tool was created to simplify mileage tracking for private ambulance services, truck drivers, and independent contractors who are reimbursed or paid based on out-of-county travel.
      </p>

      <h2>Who Created CountyLee?</h2>
      <p>
        CountyLee was created by <strong>Leaton Mitchell</strong>. The tool was designed in response to the need for a simple, accurate way to separate total trip mileage from out-of-county mileage—something that generic mileage or navigation apps do not do. If you have questions or feedback, you can reach Leaton at <a href="mailto:leatonm@gmail.com">leatonm@gmail.com</a> or visit <a href="https://leaton.dev" target="_blank" rel="noopener noreferrer">leaton.dev</a>.
      </p>

      <h2>How It Works</h2>
      <p>
        Unlike generic mileage calculators, CountyLee uses your start and end addresses to:
      </p>
      <ul>
        <li>Identify the county where your trip starts and the county where it ends.</li>
        <li>Calculate the total driving distance between the two points.</li>
        <li>Determine how many of those miles were driven <strong>outside your starting county</strong>.</li>
      </ul>
      <p>
        That out-of-county figure is what many employers and contracts use for reimbursement. The tool relies on public map and county boundary data to compute these values. Results are intended for record-keeping and reference; always confirm reimbursement rates and policies with your employer or accountant.
      </p>

      <h2>Why &quot;Out of County&quot; Matters</h2>
      <p>
        In private ambulance, transport, and trucking work, pay or reimbursement often depends on whether miles are in-county or out-of-county. Keeping an accurate log helps you document your trips and ensure you are compensated correctly. CountyLee gives you a clear breakdown so you can keep records for payroll, expense reports, or tax purposes.
      </p>

      <p>
        Ready to try it? Use the <Link to="/calculator">Calculator</Link> or read our <Link to="/faq">FAQ</Link> for tips and common questions.
      </p>
    </article>
  );
}

export default About;
